import React, { useEffect } from 'react';
import { useField } from 'formik';
import { NumericFormat } from 'react-number-format';
import classNames from '../../../utility/classNames';
import DescriptionTooltipModal from './DescriptionTooltipModal';
import Tooltip from '../../Tooltip';

function NumberInput({
  label,
  unit,
  layout = 'default',
  description,
  required,
  preValue,
  defaultValue,
  tooltipHeading,
  tooltipFormula,
  maxValue,
  ...props
}) {
  const [field, meta, helpers] = useField(props);
  const { value, touched, error } = meta;
  const { setValue, setTouched } = helpers;

  useEffect(() => {
    if (preValue) {
      setValue(preValue);
    }
    if (
      !preValue &&
      !field.value &&
      field.value !== false &&
      field.value !== 0 &&
      defaultValue !== undefined
    ) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  const handleValueChange = (values, sourceInfo) => {
    const { floatValue } = values;

    if (maxValue && floatValue > maxValue) {
      setValue(Number(maxValue));
      return;
    }

    // if user empyty the input, set value to empty string
    if (!floatValue && floatValue !== 0) {
      setValue('');
      return;
    }

    setValue(values.floatValue);
  };

  return (
    <div
      className={classNames(
        'w-full',
        (layout === 'compact' || layout === 'tableNoLabel') && 'my-0 space-y-0',
        layout === 'tableNoLabel' && 'w-full'
      )}
    >
      <div
        className={classNames(
          'sm:grid sm:items-start',
          'sm:gap-2',
          layout === 'stacked' && 'sm:gap-2',
          (layout === 'compact' || layout === 'tableNoLabel') &&
            'sm:gap-4 pt-0 border-none',
          layout === 'tableNoLabel' ? 'sm:grid-cols-2' : 'sm:grid-cols-3-inputs'
        )}
      >
        {layout !== 'tableNoLabel' && (
          <label
            htmlFor={field.name}
            className={classNames(
              'h-full flex items-center',

              layout === 'stacked' && 'col-span-3'
            )}
          >
            <span className="text-md font-normal text-neutral-900">
              {label}
              {required && <span title="required">*</span>}{' '}
              {description && layout !== 'compact' && (
                <Tooltip
                  text={description}
                  heading={tooltipHeading}
                  formula={tooltipFormula}
                  type="info"
                />
              )}
              {description && layout === 'compact' && (
                <DescriptionTooltipModal description={description} />
              )}
            </span>
          </label>
        )}

        <div
          className={classNames(
            layout === 'stacked' ? 'col-span-3' : 'col-span-2',
            'relative w-full'
          )}
        >
          <div className="relative w-full">
            <NumericFormat
              id={field.name}
              displayType="input"
              prefix={(unit === '$' && unit) || undefined}
              suffix={(unit === '%' && unit) || undefined}
              type="text"
              value={value}
              thousandSeparator={true}
              decimalScale={2}
              allowNegative={false}
              onValueChange={handleValueChange}
              onBlur={() => setTouched(true)}
              {...props}
              className={classNames(
                'block w-full border focus:border-primary bg-neutral-input focus:outline-none focus:ring-transparent  text-md  h-8 rounded-md py-0 px-3 placeholder-neutral-500 placeholder-opacity-90',
                touched && error ? 'border-warning' : 'border-transparent'
              )}
            />

            {unit && unit !== '$' && unit !== '%' && (
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <span className="text-neutral-900 text-md" id="price-currency">
                  {unit}
                </span>
              </div>
            )}
          </div>

          {/* {description && (
            <span className="block text-sm text-black font-normal">
              {description}
            </span>
          )} */}

          {touched && error ? (
            <div className="error text-base font-small text-warning ">
              {error}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default NumberInput;
